<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import type { Deal } from '@models/deal';
import Button from '@components/Button.vue';
import { useScreensizeStore } from '@stores/useScreensizeStore';
import { URL_DEAL_MESSAGING } from '@tools/routes/routes';
import { trans } from '@elements/translation';
import IconChatsFill from '@icons/ph_chats-fill.svg';
import Icon from '@components/Icon.vue';

const props = defineProps<{ deal: Deal }>();

const url = computed<string>(() => URL_DEAL_MESSAGING.replace('{id}', props.deal.id.toString()));

const { isMobile } = storeToRefs(useScreensizeStore());

const openConversation = (): void => {
  window.open(url.value, isMobile.value ? '_self' : '_blank');
};
</script>

<template>
  <Button
    variant="secondary"
    class="btn-link proposal-inbox-link"
    @click="openConversation"
  >
    <span class="proposal-inbox-link__icon" />
    <Icon
      :svg="IconChatsFill"
      height="24"
      width="24"
      fill="blue"
    />

    <span>
      {{ trans('selection_item.contact.inbox') }}
    </span>
  </Button>
</template>
